import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scan",
  "use": "icon-scan-usage",
  "viewBox": "100 100 800 800",
  "content": "<symbol class=\"icon\" viewBox=\"100 100 800 800\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-scan\"><path d=\"M128 384V160c0-17.6 14.4-32 32-32h224v64H192v192h-64z m512-192h192v192h64V160c0-17.6-14.4-32-32-32H640v64z m192 448v192H640v64h224c17.6 0 32-14.4 32-32V640h-64z m-448 192H192V640h-64v224c0 17.6 14.4 32 32 32h224v-64z m512-352H128v64h768v-64z\" p-id=\"3789\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol